import { Button } from "antd";
import { Link } from "react-router-dom";
import CheckedIcon from "../../assets/icons/CheckedIcon";
import { CustomModalProps } from "../../types";
import CustomModal from "../ui/CustomModal";

type Props = {
  type?: "report" | "queue";
  isNavigate?: boolean;
  handleOk?: () => void;
} & CustomModalProps;

export default function SuccessModal({
  type = "report",
  isNavigate,
  handleOk,
  ...rest
}: Props) {
  return (
    <CustomModal title="" footer={null} width={400} closeIcon={null} {...rest}>
      <div className="flex justify-center text-center items-center">
        <div className="text-center">
          <div className="flex justify-center text-center items-center">
            <CheckedIcon />
          </div>
          <div className="text-center justify-center text-zinc-700 text-base font-medium py-5">
            {type === "queue"
              ? "Task Request has been submitted for processing"
              : "Report Request has been submitted for processing"}
          </div>

          <Link
            to={
              isNavigate
                ? ""
                : type === "queue"
                ? "/admin/task-queue"
                : "/admin/reports"
            }
          >
            <Button type="primary" className="min-w-[100px]" onClick={handleOk}>
              Okay
            </Button>
          </Link>
        </div>
      </div>
    </CustomModal>
  );
}
